/* =========================================================
   EGO Content
   Version: 2.3.6
   Image lightbox behavior

   Shopify production filename:
   assets/ego-content.js
   Download filename: ego-content-v2-3-6-js.txt
========================================================= */

(function () {
  'use strict';

  if (window.EgoContentLightboxInitialized) return;
  window.EgoContentLightboxInitialized = true;

  var lightbox = null;
  var previousFocus = null;

  function createLightbox() {
    if (lightbox) return lightbox;

    lightbox = document.createElement('div');
    lightbox.className = 'ego-content-lightbox';
    lightbox.hidden = true;
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Full-size image');

    lightbox.innerHTML = [
      '<button type="button" class="ego-content-lightbox__close" data-ego-content-lightbox-close aria-label="Close full-size image">×</button>',
      '<figure class="ego-content-lightbox__figure">',
      '<img class="ego-content-lightbox__image" data-ego-content-lightbox-image alt="">',
      '<figcaption class="ego-content-lightbox__caption" data-ego-content-lightbox-caption hidden></figcaption>',
      '</figure>'
    ].join('');

    document.body.appendChild(lightbox);

    lightbox.addEventListener('click', function (event) {
      if (
        event.target === lightbox ||
        event.target.closest('[data-ego-content-lightbox-close]')
      ) {
        closeLightbox();
      }
    });

    return lightbox;
  }

  function openLightbox(trigger) {
    var src = trigger.getAttribute('data-ego-content-lightbox-src');
    if (!src) return;

    var alt = trigger.getAttribute('data-ego-content-lightbox-alt') || '';
    var caption = trigger.getAttribute('data-ego-content-lightbox-caption') || '';
    var modal = createLightbox();
    var image = modal.querySelector('[data-ego-content-lightbox-image]');
    var captionNode = modal.querySelector('[data-ego-content-lightbox-caption]');
    var closeButton = modal.querySelector('[data-ego-content-lightbox-close]');

    previousFocus = document.activeElement;

    image.src = src;
    image.alt = alt;

    if (caption) {
      captionNode.textContent = caption;
      captionNode.hidden = false;
    } else {
      captionNode.textContent = '';
      captionNode.hidden = true;
    }

    modal.hidden = false;
    document.documentElement.classList.add('ego-content-lightbox-open');

    if (closeButton) {
      closeButton.focus({ preventScroll: true });
    }
  }

  function closeLightbox() {
    if (!lightbox || lightbox.hidden) return;

    var image = lightbox.querySelector('[data-ego-content-lightbox-image]');

    lightbox.hidden = true;
    document.documentElement.classList.remove('ego-content-lightbox-open');

    if (image) {
      image.removeAttribute('src');
      image.alt = '';
    }

    if (previousFocus && typeof previousFocus.focus === 'function') {
      previousFocus.focus({ preventScroll: true });
    }

    previousFocus = null;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ego-content-lightbox-trigger]');
    if (!trigger) return;

    event.preventDefault();
    openLightbox(trigger);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeLightbox();
    }
  });
})();
